import GLU from '../glu2.js/src/index';

class AccountsApi extends GLU.Api {
    constructor(endpoint) {
        super(endpoint);

        this.createApiActions({
            name: 'updateUserPreferences',
            method: GLU.Api.Patch,
            path: '/account/preferences',
            credentials: true,
        });
    }
}

export default AccountsApi;
